import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  LinearProgress,
  Typography
} from '@mui/material';


function PageStatusDialog({
  isOpen,
  statusMessage
}) {
  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
    >
      <Box sx={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="p">{statusMessage}</Typography>
        <LinearProgress color="primary" />
      </Box>
    </Dialog>
  );
}

PageStatusDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export { PageStatusDialog };
